import React, { lazy } from 'react';
import { PublicRoute } from './components/PublicRoute';
import * as routesPaths from './RouteConstants';
import TermsRouteView from '../modules/TermsRouteView';
import Landing from 'containers/Landing';
import NavigationWrapper from '../components/NavigationWrapper';
import Login from '../containers/Login';
import Register from '../containers/Register';

//----LAZY ROUTES----
const Player = lazy(() => import('../providers/player.provider'));
const GTres = lazy(() => import('./../containers/GTres'));
const LoginCheckout = lazy(() =>
  import('../containers/Payment/LoginCheckout/index'),
);
const OauthCallbackView = lazy(() => import('./../modules/OauthCallbackView'));
const PlanSelect = lazy(() => import('../containers/Payment/PlanSelect'));
const Payment = lazy(() => import('../containers/Payment'));
const CompleteUser = lazy(() => import('../containers/CompleteUser'));
const ServiceRedirectView = lazy(() =>
  import('../modules/ios/ServiceRedirectView'),
);
const ForgottenPassword = lazy(() =>
  import('./../containers/ForgottenPassword'),
);
const PromoGateOnlyCode = lazy(() =>
  import('../containers/Payment/PromoGateOnlyCode'),
);
const PromoGateTicket = lazy(() =>
  import('../containers/Payment/ConfirmTransaction/ConfirmPromoGateTransaction'),
);

export const mainRoutes = [
  {
    path: routesPaths.PLAYER,
    element: (
      <NavigationWrapper>
        <Player />
      </NavigationWrapper>
    ),
  },
  {
    path: routesPaths.COMPLETE_IPTV,
    element: <CompleteUser />,
  },
  {
    path: routesPaths.REDIRECT,
    element: <ServiceRedirectView />,
  },
  {
    path: routesPaths.PLAN_SELECT,
    element: <PlanSelect />,
  },
  {
    path: routesPaths.PAYMENT,
    element: <Payment />,
  },
  {
    path: routesPaths.OAUTH_CALLBACK,
    element: <OauthCallbackView />,
  },
  {
    path: routesPaths.CHECKOUT_REDIRECT,
    element: <LoginCheckout />,
  },
  {
    path: routesPaths.FORGOTTEN_PASSWORD,
    element: <ForgottenPassword />,
  },
  {
    path: routesPaths.GTRES,
    element: (
      <NavigationWrapper>
        <GTres />
      </NavigationWrapper>
    ),
  },
  {
    path: routesPaths.PROMOGATE_ONLY_CODE,
    element: <PromoGateOnlyCode />,
  },
  {
    path: routesPaths.PROMOGATE_ONLY_CODE_CONFIRM,
    element: <PromoGateTicket />,
  },
  {
    path: routesPaths.LANDING,
    element: <PublicRoute component={Landing} />,
  },
  {
    path: routesPaths.LOGIN,
    element: <PublicRoute component={Login} />,
  },
  {
    path: routesPaths.REGISTER_FORM,
    element: <PublicRoute component={Register} />,
  },
  // {
  //   path: routesPaths.TERMS,
  //   element: <TermsRouteView />,
  // },
];
